module.exports = __webpack_public_path__ + "static/media/box-heart.63ba8c8e.svg";